import React from "react";
import { useHistory, useLocation } from "react-router-dom";

import classes from "./styles.module.scss";

import { default as ArrowDownBlue } from "~assets/images/icons/JSX/arrow-down-blue";

const TransactionHeader = ({ isCollapsed }) => {
    const history = useHistory();
    const location = useLocation();

    const canGoBack = location.key !== undefined;

    return (
        <div className={`${classes.transactionHeader} ${isCollapsed ? classes.sideBarCollapsed : ""}`}>
            {canGoBack && (
                <div className={classes.backArrow} onClick={() => history.goBack()}>
                    <ArrowDownBlue fill="#62BCF8" />
                </div>
            )}
            <h2 className={classes.headerTitle}>Transaction History</h2>
        </div>
    );
};

export default TransactionHeader;
